module.exports = __webpack_public_path__ + "static/img/pahs_logo.1c012f1b.jpg";